export const colors = {
  teal: {
    100: "#0C4851",
    200: "#80D1CA",
    300: "#008479", // Deep Sea
    400: "#0AACA0",
    500: "#ECF8F7",
    600: "#128279",
  },
  ocean: {
    100: "#9CCFE0",
    200: "#8AADD0", // Polo
    300: "#0888B2",
    400: "#065F7D",
    500: "#033647",
    600: "#2C6BAA", // Ocean
    700: "#194066",
  },
  mulberry: {
    100: "#D2A8C2",
    200: "#B06794",
    300: "#8E2666",
    400: "#631B47",
    500: "#390F29",
    600: "#631A58",
    700: "#3F133F",
  },
  grey: {
    100: "#565963",
    200: "#8E909A",
    300: "#A8AAB3",
    400: "#C9CBD5",
    500: "#E5E6EE",
    600: "#F1F1F7",
    700: "#F8F8FD",
  },
  nero: {
    100: "#A2A1A1",
    200: "#5D5D5D",
    300: "#161616", // should be text primary on light background
    400: "#101010",
    500: "#000000",
  },
  eggplant: {
    100: "#b2a0b2",
    200: "#785a79",
    300: "#3e123f",
    400: "#2b0c2c",
    500: "#190819",
  },
  cobalt: {
    100: "#014169",
    200: "#112A44",
  },
  violet: {
    100: "#BDB5D4",
    300: "#65529C",
    500: "#230871",
    700: "#1A065E",
    900: "#0C0242",
  },
  periwinkle: {
    100: "#EBF1FB",
    300: "#8AABE5",
    500: "#5887DA",
    700: "#4774D0",
    900: "#2D57C2",
  },
  flameRed: {
    100: "#F1B6B9",
    300: "#DF545D",
    500: "#D10A17",
    700: "#C60711",
    900: "#B50307",
  },
  white: "#FFF",
  black: "#000",
  cooledCarbon: "#313336",
  catSkill: "#EDF3F9",
  semantic: {
    neutral: "#6D767E",
    positive: "#32984D",
    error: "#CD1F1F",
    warning: "#E17A17",
    info: "#5887DA", // rename as neutral later
  },
  tableBorderColor: "#E5E6EE", // grey[500]
};

export const palette = {
  primary: {
    light: colors.violet[100],
    main: colors.violet[500],
    dark: colors.violet[900],
    contrastText: colors.white,
  },
  secondary: {
    light: colors.periwinkle[100],
    main: colors.periwinkle[500],
    dark: colors.periwinkle[900],
  },
  tertiary: {
    light: colors.white,
    main: colors.white,
    dark: colors.white,
    contrastText: colors.nero[300],
  },
  error: {
    light: colors.flameRed[100],
    main: colors.flameRed[500],
    dark: colors.flameRed[900],
  },
  textSecondary: {
    color: colors.grey[100],
  },
  text: {
    secondary: colors.semantic.neutral,
  },
  grey: colors.grey,
  action: {
    disabledBackground: colors.grey[300],
    disabled: colors.white,
    disabledOpacity: 0.38,
  },
  common: {
    white: colors.white,
    black: colors.black,
  },
  background: {
    paper: colors.white,
    default: colors.grey[700],
  },
};
